
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $b2eefcc3e5fdb373$exports = {};

$parcel$export($b2eefcc3e5fdb373$exports, "spectrum--large", () => $b2eefcc3e5fdb373$export$a88a8dbe29386d31, (v) => $b2eefcc3e5fdb373$export$a88a8dbe29386d31 = v);
var $b2eefcc3e5fdb373$export$a88a8dbe29386d31;
$b2eefcc3e5fdb373$export$a88a8dbe29386d31 = `_1DrGeG_spectrum--large`;


export {$b2eefcc3e5fdb373$exports as default};
//# sourceMappingURL=vars_spectrum-large_css.module.js.map
